import { useState } from 'react';
import InputForm from '../../../../InputT';
import { useTranslation } from 'react-i18next';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';
import DataType from '../../../../../Types/DataTablePiclist';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import SearchInput from '../../../../SearchInput';
import SearchModal from '../../../../SearchModal';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../../TableResizable';
import { NightShelterOutlined } from '@mui/icons-material';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import Cheque from '../../../../../Models/Cheque';

const Tab1 = (props: { etatG: boolean, form?: any, DataCheque: Cheque[], OnModif: Function }) => {

    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [Filtre, setFiltre] = useState<string>("1");
    const auth = useAuthUser()
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader();

    //Initialisation des parametres de recherche
    let searchOp: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '', Choix: 22 }
    let searchBanque: ParamsPicklist = { CodeAgence: user.codage, Table: "BANQUE", Colonne1: "CODCPT", Colonne2: "LIBELL", Colagence: 'AGECPT', Choix: 22 }
    let searchClient: ParamsPicklist = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "", Choix: 22 }

    const columns: ColumnsType<Cheque> = [
        {
            title: 'Date Saisie',
            dataIndex: 'DATOPE',
            ellipsis: true,
            width: 100,
            render: (text: any, reccord: any) => (
                <span>
                    {ReformatDate(text)}
                </span>
            )
        }
        ,
        {
            title: 'Client',
            dataIndex: 'Client',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'BANQUE',
            dataIndex: 'Lib_BANQUE',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'MONTANT',
            dataIndex: 'MONTAN',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'N° Compte',
            dataIndex: 'NUMCPT',
            ellipsis: true,
            width: 200,
            // filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.NUMCPT)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.SENSEC)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.REPECE)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.MONTANT)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.LIBELL)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Utilis)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Motif)
                        .toLowerCase()
                        .includes(value.toLowerCase())
            }
        },
        {
            title: 'Montant',
            dataIndex: 'MONTAN',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'N° Chèque',
            dataIndex: 'NUMCHQ',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'N° Cpt cheque',
            dataIndex: 'CPTCHC',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'CPTRECOUVRE',
            dataIndex: 'CPTRECOUVRE',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'Remettant',
            dataIndex: 'REMETT',
            ellipsis: true,
            width: 150,
        },
        {
            title: "",
            dataIndex: 'RelObject',
            width: 1
        }
    ];

    let informationclient = {
        searchCptClient: {
            Titre: "Recherche ",
            label: "Compte Client ",
            name: "NUMCPT", params: searchClient
        },
        searchCptRemisEn: {
            Titre: "Recherche Compte chèque à l'encaissement ",
            label: "Cpt chèque Banque à Recouvrer",
            name: "CPTCHQRECOUVRE", params: searchOp
        },
        searchCptEncaissement: {
            Titre: "Recherche Cpt chèque à l'Encaissement",
            label: "Cpt Client chèque à l'Encaissement",
            name: "CPTCHC", params: searchBanque
        },
        searchDomicilliation: {
            Titre: "Recherche Domiciliation bancaire ",
            label: "Banque de Depot ",
            name: "BANCLT", params: searchBanque
        },
        InputRemettant: {
            label: "Remettant",
            name: "REMETT"
        },
        InputNumbor: {
            label: "Numéro bordereau remise",
            name: "BORDER"
        },
        InputDatTrait: {
            label: "Date Opération",
            name: "DATOPE"
        },
        searchCodeOpe: {
            Titre: "Recherche Opération",
            label: "Opération",
            name: "CODOPE", params: searchOp
        },
        InputMontant: {
            label: "Montant",
            name: "MONTAN"
        },
        InputNumcheque: {
            label: "Numéro de chèque ",
            name: "NUMCHQ"
        },
        searchBanque: {
            Titre: "Recherche Banque",
            label: "Banque du tireur",
            name: "BANCLT", params: searchBanque
        },
        InputCptClientBanque: {
            label: "Compte Client à la Banque",
            name: "CPTCLT"
        },
        InputNotreCptBanque: {
            label: " Notre Compte à la Banque",
            name: "NUMBAN"
        }

    }

    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const onSelectChange = (newSelectedRowKeys: any) => {
        props.form.setFieldsValue(props.DataCheque[newSelectedRowKeys].RelObject);
        props.form.setFieldValue('lib_CODOPE', props.DataCheque[newSelectedRowKeys].RelObject.LIBECR);
        props.form.setFieldValue('lib_CPTCHQRECOUVRE', props.DataCheque[newSelectedRowKeys].RelObject.lib_BANCLT);

        let DateD = user.datjour;

        props.form.setFieldValue("DATOPE", DateD);
        props.form.setFieldValue('DATSAI', ReformatDate(props.DataCheque[newSelectedRowKeys].DATOPE));

        setSelectedRowKeys(newSelectedRowKeys);
        props.OnModif();
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };


    return (
        <div className='tabItem' >
            <div>
                <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"} sx={{p: 1}}>
              <legend> Remise chèque à la banque </legend>
              <Box fontStyle="inherit" className='border' width={"100%"} sx={{mb:1}} >
                 
                        <SearchInput   width={3} dissabledCode={true} dissabledLib={false} notRequired form={props.form}  Titre={informationclient.searchCodeOpe.Titre} label={informationclient.searchCodeOpe.label} name={informationclient.searchCodeOpe.name} Parametre={informationclient.searchCodeOpe.params} />
                   
                    <Box style={{ display: 'flex',marginTop:'-1%' }} >
                        <Box fontStyle="inherit" className='border-left' width={'50%'} >
                            <SearchModal disabled form={props.form} Titre={informationclient.searchCptClient.Titre} width={6} label={informationclient.searchCptClient.label} name={informationclient.searchCptClient.name} Parametre={informationclient.searchCptClient.params} />
                            <SearchModal disabled form={props.form} width={6} Titre={informationclient.searchDomicilliation.Titre} label={informationclient.searchDomicilliation.label} name={informationclient.searchDomicilliation.name} Parametre={informationclient.searchDomicilliation.params} />
                            <InputForm icon={<NightShelterOutlined />} disabled width={6} label={informationclient.InputRemettant.label} name={informationclient.InputRemettant.name} type='text' />
                            <InputForm icon={<NightShelterOutlined />} disabled width={6} label={informationclient.InputDatTrait.label} name={informationclient.InputDatTrait.name} type='date' />
                            <InputForm icon={<NightShelterOutlined />} disabled={false} width={6} label={informationclient.InputNumbor.label} name={informationclient.InputNumbor.name} type='text' />
                        </Box>

                        <Box fontStyle="inherit" className='border-left' width={'50%'}>
                            <SearchModal form={props.form} disabled Titre={informationclient.searchCptRemisEn.Titre} width={6} label={informationclient.searchCptRemisEn.label} name={informationclient.searchCptRemisEn.name} Parametre={informationclient.searchCptRemisEn.params} />
                            <SearchModal form={props.form} disabled Titre={informationclient.searchCptEncaissement.Titre} width={6} label={informationclient.searchCptEncaissement.label} name={informationclient.searchCptEncaissement.name} Parametre={informationclient.searchCptEncaissement.params} />
                            <InputForm icon={<NightShelterOutlined />} disabled notRequired width={6} label={informationclient.InputNumcheque.label} name={informationclient.InputNumcheque.name} type='text' />
                            <InputForm icon={<NightShelterOutlined />} notRequired disabled width={6} label={informationclient.InputMontant.label} name={informationclient.InputMontant.name} type='number' />

                            <Box fontStyle="inherit" className='border' width={"100%"} sx={{ visibility: 'hidden',mb:1, p: 1 }} >
                                <InputForm width={9} notRequired label={informationclient.InputRemettant.label} name={"Id"} type='text' />
                            </Box>
                        </Box>

                    </Box>
              </Box>
                    
                    <Box fontStyle="inherit" className='border' width={"100%"} sx={{mb:1}} >
                        <Table sticky={true} columns={columns} rowSelection={{ type: 'radio', ...rowSelection, getCheckboxProps: (reccord) => ({ disabled: false }) }} size='small' style={{ width: '100%' }} pagination={false} scroll={{ y: 270, x: 1200 }} dataSource={props.DataCheque} />
                    </Box>
                </Box>

                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </div>
    );
}
export default Tab1;
